import { CollectionState } from "./BaseModel";
import { ReviewDTO } from "./dto/ReviewDTO";

export interface ReviewsState extends CollectionState<ReviewDTO> {}

export const InitialReviews: ReviewsState = {
    rows: [],
    totalPages: 0,
    totalRows: 0,
};
